import styles from "./campain.module.css";
import { FaStopCircle } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { BsStarHalf } from "react-icons/bs";
import { AiFillDelete } from "react-icons/ai";
import ReactTooltip from "react-tooltip";
import Modal from "./modal/Modal";
const BoxCustomer = ({
  item,
  deleteHandler,
  index,
  customers,
  setCustomers,
  setSelectedItem,
}) => {
  const editHandler = () => {
    setSelectedItem(index);
    console.log(index);
  };
  const stopHandler = () => {
    setSelectedItem(index);
    console.log(index);
  };
  return (
    <div
      className={`  w-100  ${styles.sec}`}
      style={{
        borderRadius: " 10px",
      }}
    >
      <div className={`d-flex flex-wrap ${styles.secondry}`}>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            شناسه
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.id}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            برچسب های کاربر
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.tags}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد سرنخ
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.clue ? "فعال" : "غیر فعال"}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد سرنخ فعال
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.numClue}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد پیگیری
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.numPrevention}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد مشتری جذب شده
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.numCustomer}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            زمان ثبت
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.registerTime}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            زمان شروع
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.startTime}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            زمان پایان
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.endTime}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عملیات{" "}
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal`}
              onClick={editHandler}
            >
              <h4 data-tip="ویرایش کمپین">
                <FiEdit className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModaldel`}
              onClick={stopHandler}
            >
              <h4 data-tip="توقف کمپین">
                <FaStopCircle className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxCustomer;
